export const LANGUAGE_CONSTANTS = {
  //Common Constants
  LANGUAGE: "ENGLISH",
  WING: "Wing",
  MAXIMUM_OF_CHARACTERS: "Maximum {} characters are allowed.",
  MINIMUM_OF_CHARACTERS: "You must add minimum {} characters.",
  MAXIMUM_OF_CHARACTER: "Maximum 50 characters are allowed.",
  MINIMUM_OF_CHARACTER: "You must add minimum 3 characters.",
  //Login Page Constants
  LOGIN_HEADING_TEXT: "Login",
  LOGIN_BUTTON_TEXT: "LOGIN",
  LOGIN_FORM_EMAIL_TEXT: "Email",
  LOGIN_FORM_Password_TEXT: "Email",
  LOGIN_BUTTON: "Login",
  LOGIN_FORGOT_PASSWORD_LINK: "forgot password",
  LOGIN_ACCESS_DENIED: "You are not Authorized to access web portal.",
  FAILED_TO_UPDATED_PASSWORD_TRY_AGAIN: "Failed to update password. Try again.",
  FAILED_TO_UPDATE_PHONE_NUMBER_TRY_AGAIN:
    "Failed to update phone number. Try again.",
  SUCCESSFULLY_UPDATED: "Successfully updated.",
  SUCCESSFULLY_UPDATED_TWO_STEP_VERIFICATION:
    "Successfully updated 2-Step Verification.",
  SUCCESSFULLY_UPDATED_PUSH_NOTIFICATION:
    "Successfully updated Push Notification.",
  SUCCESSFULLY_UPDATED_FACE_ID: "Successfully updated Face ID.",
  SUCCESSFULLY_DELETED: "{} successfully deleted.",
  SUCCESSFULLY_CREATED: "{} successfully created.",
  SUCCESSFULLY_ADDED: "{} successfully added.",
  UPDATED_SUCCESSFULLY: "{} successfully updated.",
  SUCCESSFULLY_ADDED: "{} successfully added.",
  NUMBER_OF_RETRIES_EXCEED:
    "Number of re-tries exceeded, please try again in a while.",

  RECORD_NOT_FOUND: "Record not found.",
  NO_FLOORS_AVAILABLE_IN_BULIDING: "No floors available in this building.",
  SELECT_ALL: "Select All",
  UNIT: "Unit",
  BUILDING: "Building",
  UNIT_NOT_FOUND_IN_THIS_FLOOR: "Unit found in this foor.",
  ACCESS_POINT_NOT_FOUND: "Access Point not found.",
  //Login Form
  PLEASE_ENTER_A_VALID_EMAIL: "Please enter a valid email.",
  PLEASE_ENTER_A_VALID_PHONE_NUMBER: "Please enter a valid phone number",
  YOU_MUST_ENTER_A_VALID_PASSWORD: "You must enter a valid password.",
  ONLY_MENTIONED_SPECIAL_CHARACTERS_ARE_ALLOWED:
    "Only mentioned special characters are allowed.",
  PASSWORD_MUST_FULLFILL_ALL_THE_MENTIONED_REQUIREMENTS:
    "Password must fullfill all the mentioned requirements.",
  YOU_MUST_ENTER_A_VALID_EMAIL_OR_PHONE:
    "You must enter a valid email or phone number.",
  YOU_MUST_ENTER_A_VALID_EMAIL:
    "You must enter a valid email ID to recover the password.",
  YOU_MUST_ENTER_A_VALID_PHONE: "You must enter a valid phone number.",
  LOGIN_WITH_EMAIL: "Login with email?",
  LOGIN_WITH_PHONE_NUMBER: "Login with phone number?",
  EMAIL_ENTERED_IS_INCORRECT:
    "The email or phone number you entered is incorrect. Please try again.",

  PHONE_NUMBER_ENTERED_IS_INCORRECT:
    "The phone number you entered is incorrect. Please try again.",
  LIMIT_EXCEED_THAN_50_CHARACTERS: "Limit exceeded  than 50 characters.",
  LIMIT_EXCEED_THAN_20_CHARACTERS: "Limit exceeded  than 20 characters.",
  MAXIMUM_OF_20_CHARACTERS: "Maximum 20 characters are allowed.",
  MAXIMUM_OF_50_CHARACTERS: " Maximum 50 characters are allowed.",
  LIMIT_EXCEED_THAN_25_CHARACTERS: "limit exceeded  than 25 characters.",
  BOTH_PASSWORD_SHOULD_MATCH: "Both passwords should match.",
  PASSWORD: "Password",
  PASSWORD_ENTERED_IS_INCORRECT:
    "The password you entered is incorrect. Please try again.",
  REMEMBER_ME: "Remember me",
  FORGOT: "Forgot",
  EMAIL: "Email",
  PHONE: "Phone",
  PHONE_NUMBER_IS_NOT_VALID: "Phone number is not valid.",
  LOGIN_WITH_EMAIL_OR_PHONE: "Login with email or phone number.",
  USERNAME: "Username",
  ENTER_PASSWORD_DOES_NOT_MATCH_PASSWORD_POLICY:
    "The entered password doesn't meet the password policy.",
  DELETE_ACCOUNT_CONFIRMATION:
    "Your account and all associated data has been successfully deleted.",
  OLD_NEW_PASSWORD_CANNOT_BE_SAME:
    "New password cannot be same as existing password",
  //OTP Verification
  NAVIGATE_BACK_TO_LOGIN: "Back to Login",
  VERIFICATION_HEADING_TEXT: "Verify Account",
  VERIFICATION_INFORM_SEND_CODE:
    "Please enter the verification code sent to your phone number ending in",
  VERIFICATION_RECEIVE_CODE_TEXT: "Didn't receive a code?",
  VERIFICATION_RESEND_CODE_LINK: "Resend Code",
  VERIFICATION_SEND_CODE_TO_EMAIL: "to my email",
  EIGHT_TO_TWENTY_CHARACTERS: "* 8-20 Characters.",
  ATLEAST_ONE_UPPERCASE_LETTER: "* at least one upper-cased letter.",
  ATLEAST_ONE_LOWERCASE_LETTER: "* at least one lower-cased letter.",
  ATLEAST_ONE_NUMBER: "* at least one number",
  ATLEAST_ONE_SPECIAL_CHARACTER:
    "* at least one special character ^ $ * ? - ! @ # % &",
  OTP_VERIFICATION_FAILED: "OTP Validation failed.",
  FAILED_TO_SEND_CODE_TRY_AGAIN: "Failed to send code. Please try again.",
  PERCENTAGE: "%",
  //Verification Component
  RESEND_CODE: "Resend Code",
  DID_NOT_RECIEVE_ACODE: " Didn't receive a code?",
  TO_MY_EMAIL: "to my email.",
  TO_MY_PHONE: "to my phone.",
  PLEASE_ENTER_THE_VERIFICATTION_CODE_SENT_TO_YOUR_EMAIL:
    "Please enter the verification code sent to your email.",
  PLEASE_ENTER_THE_VERIFICATTION_CODE_SENT_TO_YOUR_PHONE_NUMBER:
    "Please enter the verification code sent to your phone number ending in",
  VERIFY_ACCOUNT: "Verify Account",
  CODE_HAS_BEEN_SENT_TO_YOUR_EMAIL: "Code has been sent to your Email.",
  CODE_HAS_BEEN_SENT_TO_YOUR_PHONE: "Code has been sent to your Mobile Phone.",
  PHONE_NUMBER_HAS_BEEN_UPDATED_SUCCESSFULLY:
    "Phone number updated successfully.",

  //Add Building Component
  LETS_GET_YOU_STARTED:
    "Let's get you started by adding buildings to your site.",
  LETS_GET_STARTED: "Let's Get Started",
  ALL_BUILDINGS: "All Buildings",
  EDIT_SITE_INFORMATION: "Edit Site Information",
  //Select Site Component
  PLEASE_SELECT_SITE: "Please select a site",
  NO_SITE_SELECTED: "No site selected",

  //Building Details Component
  PLEASE_SELECT_A_BUILDING:
    "Please select a Building to display the information.",
  PLEASE_SELECT_A_UNIT_OR_ACCESSPOINT:
    "Please select a Unit or an Access Point to display the information.",
  PLEASE_SELECT_A_UNIT: "Please select a Unit to display the information.",

  NO_FLOORS_IN_THIS_BUILDING: "No floors in this building.",
  NO_UNIT_IN_THIS_BUILDING: "No unit in this building.",
  NO_ACCESS_POINTS_AVAILABLE_IN_THIS_BUILDING:
    "No access point available in this building.",
  NO_USER_IS_AVAILABLE: "No User is available.",
  NO_USER_ACCESS_IS_AVAILABLE: "No User access is available.",
  REQUEST_TO_GET_FLOORS_FAILED:
    "Request to get floors failed due to some error.",
  REQUEST_TO_ADD_FLOOR_FAILED: "Request to add floor failed due to some error.",
  FAILED_FLOOR_LIMIT_EXCEEDEDS:
    "Unable to complete request. Maximum number of Floors allowed are 50 per Building.",
  REQUEST_TO_UPDATE_FLOOR_FAILED:
    "Request to update floor failed due to some error.",
  REQUEST_TO_ADD_FLOOR_FAILED_LIMIT_EXCEED:
    "Unable to complete request. Maximum number of Units allowed are 1000 per Site.",
  REQUEST_TO_DELETE_FLOOR_FAILED:
    "Request to delete floor failed due to some error.",
  REQUEST_TO_DELETE_BUILDING_FAILED:
    "Request to delete building failed due to some error.",
  USER_NOT_AUTHORIZED_TO_DELETE_USER:
    "User in not authorized to perform this action.",
  NO_FLOORS_AVAILABLE: "No floors available.",
  NO_ACTIVITIES_AVAILABLE: "No activities available.",
  NO_FLOORS_AVAILABLE_FOR_APPLIED_FILTER:
    "No units are available against the applied filter.",
  INVALID_REQUESTED_DATA_List_OF_FLOORS:
    "Data is not valid for list of floors. Can not parse invalid data.",
  INVALID_REQUESTED_DATA_ADD_FLOOR:
    "Data is not valid for add floor. Can not parse invalid data.",
  INVALID_REQUESTED_DATA_DELETE_FLOOR:
    "Data is not valid for Delete floor. Can not parse invalid data.",
  LOCK_INSTALLED_PROCESS:
    "This lock has not been activated. Please use the mobile app to activate the lock.",
  LOCK_DEACTIVATED:
    "The lock is in pending deactivation state. Please go through the de-activation process.",
  BATTERY_LOW_MESSAGE: "Low Battery. Replace batteries soon.",
  BATTERY_VERY_LOW_MESSAGE: "Very Low Battery. Replace batteries soon.",
  BATTERY_CRITICALLY_LOW_MESSAGE:
    "Critically Low Battery. Replace batteries now.",
  LOW_BATTERY: "Low Battery",
  VERY_LOW_BATTERY: "Very Low Battery",
  TOO_LOW_TO_OPERATE_BATTERY: "To Low to Operate Battery",
  SEE_DETAILS: "See details",
  LEARN_MORE: "Learn More",
  DEVICE_LIMIT_EXCEEDED:
    "Unable to complete request. Maximum number of Locks allowed are 20 per Unit.",
  //Add Building Details Component
  NEW_BUILDING: "New Building",
  BUILDING: "Building",
  ADD_DETAILS: "Add Details",
  BUILDING_NAME: "Building Name*",
  YOU_MUST_ENTER_BUILDING_NAME: "You must enter building name.",
  BUILDING_PHOTO: "Building Photo*",
  FAILED_TO_LOAD_BUILDINGS: "Failed to load buildings.",
  RETRY_TEXT: "Retry",
  BUILDING_NAME_ALREADY_EXISTS:
    "Building name already exists. Please select a unused name to continue.",

  //Add Floor Details Component
  YOU_MUST_ENTER_UNITS_PER_FLOOR: "You must enter Units per floor.",
  NO_OF_UNITS_PER_FLOOR: "# Of Units Per Floor",
  NO_OF_UNITS_PER_FLOOR_ASTERIK: "# Of Units Per Floor*",
  YOU_MUST_ENTER_ACCESSPPOINTS_PER_FLOOR:
    "You must enter Access points per floor.",
  NO_OF_ACCESSPOINTS_PER_FLOOR: "# Of Access Points Per Floor",
  NO_OF_ACCESSPOINTS_PER_FLOOR_ASTERIK: "# Of Access Points Per Floor*",
  NOT_SPECIFIED: "Not Specified",
  WING_NAME_OPTIONAL: "Wing Name (Optional)",
  YOU_MUST_ENTER_FLOOR_NUMBER: "You must enter Floor Number or Letter.",
  FLOOR_AND_WING_NAME_ALREADY_EXISTS:
    "The combination of floor and wing name already exist.",
  GROUP_NAME_ALREADY_EXISTS: "Group name already exists.",
  FLOOR_NUMBER_OR_LETTER: "Floor Number Or Letter*",
  NEW_FLOOR: "New Floor",
  EDIT_FLOOR: "Edit Floor",
  ADD_A_FLOOR: "Add a Floor",
  NEW_FLOOR_DETAILS: "New Floor Details",
  FLOOR_DETAILS: "Floor Details",
  REMOVE_A_FLOOR: "Remove a Floor",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_FLOOR:
    "Are you sure you want to remove this Floor?",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_BUILDING:
    "Are you sure you want to remove this Building?",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_LOCK:
    "Are you sure you want to remove this Lock?",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_DEVICE:
    "Are you sure you want to remove this Device?",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_FLOOR:
    "By moving forward you will lose all information associated with this floor.",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_BUILDING:
    "By moving forward you will lose all information associated with this building.",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_INFORMATION_LOCK:
    "By moving forward you will lose information of lock.",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_INFORMATION_DEVICE:
    "By moving forward you will lose information of Device.",
  REMOVE_FLOOR: "Remove this floor",
  REMOVE_BUILDING: "Remove this building",
  FLOOR_ALREADY_EXIST: "Floor already exist.",
  NO_UNIT_IN_THIS_FLOOR: "No unit in this floor.",
  ACCESS_POINT_COUNT_SHOULD_BE_GREATER:
    "Access point count should be greater than or equal to",
  UNIT_COUNT_SHOULD_BE_GREATER: "Unit count should be greater than or equal to",

  // Edit Site Component

  EDIT_SITE: "Edit Site",
  SITE_NAME: "Site Name*",
  TIME_ZONE: "Time Zone*",
  YOU_MUST_ENTER_MIN_FIVE_CHAR: "You must add minimum 5 characters.",
  YOU_MUST_ENTER_MIN_TWO_CHAR: "You must add minimum 2 characters.",
  YOU_MUST_ENTER_SITE_NAME: "You must enter site name.",
  YOU_MUST_ENTER_VALID_SITE_NAME: "You must enter a valid site name.",
  YOU_MUST_ENTER_VALID_DEVICE_NAME: "You must enter a valid device name.",
  YOU_MUST_ENTER_VALID_SITE_ADDRESS: "You must enter a valid site address.",
  EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED: "Extra white spaces are not supported.",
  YOU_MUST_ENTER_VALID_WING_NAME: "You must enter a valid wing name.",
  YOU_MUST_ENTER_VALID_FLOOR_NUMBER: "You must enter a valid floor number.",
  YOU_MUST_ENTER_VALID_LOCK_NAME: "You must enter a valid lock name.",
  YOU_MUST_ENTER_VALID_UNIT_NAME: "You must enter a valid unit name.",
  YOU_MUST_ENTER_VALID_AP_NAME: "You must enter a valid access point name.",
  YOU_MUST_ENTER_VALID_BUILDING_NAME: "You must enter a valid building name.",
  YOU_MUST_ENTER_VALID_BUILDING_ADDRESS:
    "You must enter a valid building address.",
  FORMAT_NOT_SUPPORTED:
    "File type is not supported. The Supported file types are .jpg, .png, and .jpeg",
  IMAGESIZE: "Image size should not be more than 25 MB.",
  SITE_PHOTO: "Site Photo*",
  SITE_PHOTO_IS_REQUIRED: "Site Photo is required.",
  BUILDING_PHOTO_IS_REQUIRED: "Building Photo is required.",
  TIMEZONE: "Timezone*",
  PLEASE_SELECT_A_TIMZEZONE: "Please select a Timezone.",

  //Building Unit Details Component
  LOCKS: "Lock",
  DEVICE_LOCKS: "Locks",
  USER_LOCKS: "Locks",
  DEVICE: "Device",
  USERS: "Users",
  USER_OR_USERS: "User(s)",
  GROUP_USERS: "Group User(s)",
  USER: "User",
  UNIT: "Unit",
  DEVICE: "Device",
  DEVICES: "devices",
  ASSIGN_A_DEVICE: "Assign a Device",
  ACCESS_POINT: "Access Point",
  ASSIGN_ACCESS: "Assign Access",
  REMOVE_UNIT: "Remove Unit",
  REMOVE_ACCESS_POINT: "Remove Access Point",

  //Building Details Component
  DETAILS: "Details",
  ACTIVITY: "Activity",

  //Remove Floor Unit Item
  DELETE_UNIT: "Delete Unit",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_UNIT:
    "Are you sure you want to remove this Unit?",
  ARE_YOU_SURE_YOU_WANT_TO_ACCESS_POINT:
    "Are you sure you want to remove this Access Point?",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO:
    "By moving forward you will lose all information associated with this unit.",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_AP:
    "By moving forward you will lose all information associated with this access point.",
  YES: "YES",
  NO: "NO",

  //Floor Management Service

  FAILED_TO_UPDATE_UNIT: "Failed to update unit due to some error occurred.",
  YOU_MUST_ENTER_A_VALID_UNIT_NAME: "You must enter a valid unit name.",
  FAILED_TO_UPLOAD_IMAGE_SERVER_ERROR:
    "Image failed to load, server error. Please try again.",
  INVALID_REQUESTED_DATA_List_OF_UNIT:
    "Data is not valid for list of sites. Can not parse invalid data.",
  REQUEST_TO_DELETE_UNIT_FAILED:
    "Request to delete unit failed due to some error.",
  REQUEST_TO_DELETE_ACCESS_POINT_FAILED:
    "Request to delete access point failed due to some error.",
  INVALID_REQUESTED_DATA_DELETE_UNIT:
    "Data is not valid for Delete unit. Can not parse invalid data.",

  FAILED_TO_LOAD_FLOORS_OF_THIS_BUILDING:
    "Failed to load floors of this building.",

  //Edit Floor Unit Component
  SAVE: "SAVE",
  UNIT: "Unit",
  UNIT_NUMBER: "Unit Number",
  UNIT_NAME_ASTERISK: "Unit Name*",
  UNIT_NAME: "Unit Name",
  UNIT_NAME_ALREADY_EXIST: "Unit name already exist.",
  ENTER_UNIT_Name: "Enter unit name",
  UNIT_NAME_IS_REQUIRES: "Unit name is required.",

  //Shared Constants
  DONE: "DONE",
  CONTINUE: "CONTINUE",
  ADD_NEW_ACCESS: "ADD NEW ACCESS",
  SKIP: "Skip",
  ADD_FLOOR: "ADD FLOOR +",
  ADDRESS: "Address*",
  YOU_MUST_ENTER_ADDRESS: "You must enter address.",
  ADD_BUILDINGS: "ADD BUILDINGS +",
  ADD_BUILDING: "ADD BUILDING +",
  EDIT_DETAILS: "Edit Details",
  VERIFICATION_CODE_IS_INCORRECT: "Invalid verification code.",
  VERIFICATION_CODE_IS_EXPIRE: "Verification code is expired.",
  HI_TEXT: "Hi,",
  //Site Management Service
  NO_SITE_FOUND_AGAINST_THIS_USER: "No site found against this user.",
  REQUEST_TO_GET_SITES_FAILED: "Request to get sites failed due to some error.",
  INVALID_REQUESTED_DATA_List_OF_SITES:
    "Data is not valid for list of sites. Can not parse invalid data.",
  FAILED_TO_UPDATE_SITE: "Failed to update site due to some error occurred.",
  SITE_ALREADY_EXISTS: "Site with same name already exists.",
  SERVER_NOT_ABLE_PERFORM_REQUEST:
    "400 (Bad Request) server was not able to perform your request.",
  SERVER_UNAUTHORIZED_REQUEST:
    "The request has not been applied because it lacks valid authentication credentials.",
  UNABLE_TO_CONNECT_INTERNET:
    "Unable to connect to the Internet. Please confirm network connection and refresh to try again.",
  //Building Management Service
  NO_BUILDING_IN_THIS_SITE: "No building found in this site.",
  REQUEST_TO_GET_BUILDINGS_FAILED:
    "Request to get buildings failed due to some error.",
  INVALID_REQUESTED_DATA_List_OF_BUILDINGS:
    "Data is not valid for list of buildings. Can not parse invalid data.",
  FAILED_TO_UPDATE_BUILDING:
    "Failed to update building due to some error occurred.",
  FAILED_TO_ADD_BUILDING: "Failed to add building due to some error occurred.",
  BUILDINGS_LIMIT_EXCEEDED:
    "Unable to complete request. Maximum number of Buildings allowed are 200 per Site.",
  INVALID_REQUESTED_DATA_OF_BUILDING:
    "Data is not valid for building. Can not parse invalid data.",

  //Pre-signed URL
  FAILED_TO_GET_PRE_SIGNED_URL: "Failed to get pre-signed url.",

  // Add user
  USER_FIRST_NAME: "First Name*",
  USER_LAST_NAME: "Last Name*",
  YOU_MUST_ENTER_FIRST_NAME: "You must enter first name.",
  PLEASE_ENTER_A_VALID_NAME: "Please enter a valid name.",
  YOU_MUST_ENTER_LAST_NAME: "You must enter last name.",
  FIRST_LETTER_MUST_BE_ALPHABETIC_CHARACTERS_ONLY:
    "First letter must be alphabetic characters only.",
  USER_ADD_USER: "Add User",
  USER_ADD_USERS: "Add Users",
  USER_NEW_USER: "New User",
  IMPORT_FROM_CSV: "Import from csv",
  USER_GROUP: "User Group",
  END_TIME_SHOULD_BE_GREATER_THAN_START_TIME:
    "End time is earlier than start time.",
  USER_ALREADY_EXISTS: "User already exists in this group.",

  // Select Building
  ACCESS: "Access",
  BUILDING_GRAND_ACCESS_TO_USER: "Grant access to user.",
  BUILDING_START_BY_SELECTING_BUILDING: "Start by selecting a building.",
  BUILDING_IS_REQUIRED: "Building is required.",
  // user group
  USER_GROUP_GRANT_ACCESS_TITLE:
    "Grant access to user by selecting a User Type.",
  GRANT_ACCESS_TITLE_TO_USER_BY_GROUP:
    "Grant access to user by selecting a Group.",

  // Access Time
  STARTS: "Starts",
  ACCESS_TIME_EXPIRIES: "Expiries",
  ACCESS_TIME_REPEAT: "Repeat",
  ACCESS_TIME_START_IS_REQURED: "You must enter start date.",
  ACCESS_TIME_START_TIME_IS_REQURED: "You must enter start time.",
  ACCESS_TIME_END_TIME_IS_REQURED: "You must enter end time.",
  ACCESS_TIME_WEEK_REQURED: "You must select atleast one day.",
  ENTER_REPEAT_START_TIME_AND_REPEAT_END_TIME:
    "You must enter repeat start time and repeat end time",
  ACCESS_TIME_START_IS_MAX: "Not valid.",
  ACCESS_TIME_EXPIRE_IS_MIX: "Not valid.",
  ACCESS_TIME: "Access Time",
  ACCESS_TIME_NOW: "Now",
  EXPIRES: "Expires",
  ACCESS_TIME_DEFINE_ACCESS_TIME_FOR_NEW_USER:
    "Define access time for your new user.",
  ACCESS_TIME_OPTIONAL: "(Optional)",
  NEVER: "Never",
  ACCESS_TIME_REPEAT: "Repeat",
  ACCESS_TIME_START_TIME: "Start Time",
  ACCESS_TIME_END_TIME: "End Time",
  ACCESS_TIME_DAYS_OF_THE_WEEK: "Days of the Week",
  ACCESS_TIME_AM: "AM",
  ACCESS_TIME_PM: "PM",

  // Access Detail Email
  ACCESS_DETAIL_EMAIL: "Email",
  ACCESS_DETAIL_EMAIL_ASTERISK: "Email*",
  ACCESS_DETAIL_EMAIL_IS_REQURED: "You must enter email.",
  ACCESS_DETAIL_EMAIL_IS_INVALID: "Not valid.",
  ACCESS_DETAIL_REGION: "Region",
  ACCESS_DETAIL_REGION_ASTERISK: "Region*",
  ACCESS_DETAIL_REGION_IS_REQURED: "You must enter region.",
  ACCESS_DETAIL_REGION_IS_INVALID: "Not valid.",
  ACCESS_DETAIL_PHONE: "Mobile",
  ACCESS_DETAIL_PHONE_ASTERISK: "Mobile*",
  ACCESS_DETAIL_PHONE_IS_REQURED: "You must enter phone.",
  ACCESS_DETAIL_PHONE_NUMBER_IS_REQURED: "You must enter phone number.",
  ACCESS_DETAIL_PHONE_IS_INVALID: "Not valid.",
  ACCESS_DETAIL_SHARE_ACCESS_WITH_USER: "SHARE ACCESS WITH USER",
  FAILED_TO_SHARE_ACCESS_SERVER_ERROR:
    "Access not shared, server error. Please try again.",
  SHARE_ACCESS_ENTITIES_LIMIT_EXCEEDED: "Max Share Access Limit is 500.",
  FAILED_EMAIL_ACCOCIATED_EMAIL_ALREADY_ACCESS:
    "Account associated with this email already has access.",
  FAILED_END_TIME_GREATER_START_TIME:
    "End Time should be greater than Start Time.",
  FAILED_DATE_END_TIME_GREATER_START_DATE_TIME:
    "End Date Time should be greater than Start Date Time.",
  FAILED_END_TIME_IS_EARLIER_THAN_START_TIME:
    "End time is earlier than Start time.",
  FAILED_START_TIME_IS_EARLIER_THAN_CURRENT_TIME:
    "Start time is earlier than Current time.",
  FAILED_END_TIME_IS_EARLIER_THAN_CURRENT_TIME:
    "End time is earlier than Current time.",
  FAILED_PHONE_ACCOCIATED_PHONE_ALREADY_ACCESS:
    "Account associated with this phone number already has access.",
  ACCESS_DETAIL_USER_ACCESS: "Share User Access",
  ACCESS_DETAIL_YOUVE_CREATED: "You've created",
  ACCESS_DETAIL_UNIT: "Unit",
  ACCESS_DETAIL_LIKE_TO_SHARE_DETAIL:
    "profile. Would you like to share the access detail by email and/or phone?",
  FAILED_TO_GET_FLOORS_INTERNET_ISSUE:
    "Failed to get floors. Please check your internet connection or try again later.",

  //  Access Shared completed
  ACCESS_COMPLETED_ADD_ANOTHER_USER: "ADD ANOTHER USER",
  //Filter Unit Component
  FILTER_UNITS: "Filter Units",
  SEE_RESULTS: "SEE RESULTS",
  SEE_MORE: "See More",
  RESET: "Reset",
  FILTER_BY: "Filter By",
  FILTER_BY_USER_TYPE: "Filter By User Type",
  FILTER_BY_USER_STATUS: "Filter By User Status",
  NO_WING_IN_THIS_BUILDING: "No wing found in this building.",
  WING: "Wing",
  WING_EMPTY: "No wings have been assigned to this floor.",
  FLOOR: "Floor",
  FLOORS: "Floors",
  ACCESS_COMPLETED_SHARE_ACCESS: "Access Shared",
  ACCESS_COMPLETED_ACCESS_UPDATED: "Access Updated",
  ACCESS_COMPLETED_USER: "User",
  ACCESS_COMPLETED_CREATED_SHARED_SUCCESSFULLY:
    "Access has been shared successfully.",
  UNIT_IS_ALREADY_IN_PENDING_DELETE_STATE:
    "Unit is already in pending delete state.",
  UNIT_IS_IN_PENDING_DELETE_STATE_AND_CAN_NOT_BE_UPDATED:
    "Unit is in Pending Delete state and can not be updated.",

  //user details management
  USER_PROFILE: "User Profile",
  PLEASE_SELECT_A_USER_TO_DISPLAY:
    "Please select a user to display their information",
  FAILED_TO_GET_USER_IN_THIS_SITE: "Failed to get user in this site.",
  NO_DETAILS_AVAILABLE_FOR_THIS_USER: "No details available for this user.",
  YOUR_ACCESS_HAS_EXPIRED_CONTACT_INDIVIDUAL:
    "Your access has expired. Please contact the individual who granted you access to renew if required.",
  ACCESS_EXPIRED: "Access Expired.",
  FAILED_TO_UPDATE_CREDENTAIL: "Failed to update credential.",

  //Edit Floor Unit Component
  TITLE: "Confirm Navigation",
  HEADING_TEXT: "Unsaved Changes",
  BODY_TEXT:
    "You are about to leave this page without saving. All changes will be lost.",
  FOOTER_TEXT: "Are you sure you want to leave this page?",
  FAILED_TO_GET_USERS_IN_THIS_SITE: "Failed to get users in this site.",
  FAILED_TO_GET_DASHBOARD_DETAILS: "Failed to get dahboard details.",
  PLEASE_CHECK_YOUR_INTERNET_CONNECTION_AND_TRY_AGAIN:
    "Please check your internet connection and try again.",
  FAILED_TO_GET_PARTNER_DEVICES: "Failed to get partner device.",
  UNABLE_TO_UPDATE_DEVICE_ON_PARTNER: "Device is Offline.",

  //Generic error messages
  YOUR_PROVIDED_FIELDS_HAS_NULL_VALUE: "Your provided field(s) has null value.",
  YOU_PROVIDED_BAD_ARGUMENT: "Your provided data has bad argument.",
  YOUR_RETRY_LIMIT_HAS_EXCEEDED: "Your retry limit has exceeded.",
  SERVICE_IS_NOT_AVAILABLE_PLEASE_TRY_LATER:
    "Service is not available. Please try again later.",
  YOU_ARE_NOT_AUTHORIZED_TO_MAKE_THIS_CALL:
    "You are not authorized to make this call.",
  YOUR_REQUEST_IS_NOT_CORRECT: "Your request is not correct.",

  // auto logout
  ABOUT_TO_LOGOUT: "About to logout",
  STAY_LOGGED_IN: "Stay Logged In",
  YOU_ARE_ABOUT_TO_LOGOUT_FOR_INACTIVITY:
    "You are about to logout for inactivity.",
  //Version Info Component
  VERSION: "Version:",
  DATE: "Date:",
  WEB_VERSION_INFO: "Web Version Info",
  API_VERSION_INFO: "API Version Info",
  VERSION_INFO: "Version Info",

  //Activity component
  VIEW_ALL: "VIEW ALL",
  VIEW_MORE: "VIEW MORE",

  //user management
  HOME_ACCESS: "Home Access",
  OTHER_ACCESS: "Other Access",
  TEMPORARY_ACCESS: "Temporary Access",
  DELETE_USER: "Delete User",
  FILTER_USER: "Filter Users",
  TIME_REMAINING: "Time Remaining",
  ACCESS_POINTS: "Access Points",
  UNITS: "Units",
  FAILED_TO_GET_USERS_ACCESS_GROUP: "Failed to get user group.",
  NO_USER_FOUND: "No user found.",

  //Edit Acces Point Details
  EDIT_ACCESS_POINT_DETAILS: "Edit Access Point Name",
  EDIT_UNIT_DETAILS: "Edit Unit Name",
  EDIT: "Edit",
  UNIT_NAME: "Unit Name",
  ACCESS_POINT_NAME: "Access Point Name",
  ACCESS_POINT_ASTERISK: "Access Point Name*",
  ACCESS_POINT_NAME_IS_REQUIRED: " Access point name is required.",

  //Edit Access Point Details Component
  NO_ACCESSPOINT_IN_THIS_FLOOR: "No accesspoint in this floor.",
  ACCESSPOINT_NAME_ALREADY_EXIST: "Accesspoint name already exist",
  FAILED_TO_UPDATE_ACCESSPOINT:
    "Failed to update accesspoint due to some error occurred.",
  FAILED_TO_UPDATE_USER_ACCESS:
    "Failed to update user access due to some error occurred.",
  //Account Details Component
  ACCOUNT_SETTING: "Account Settings",
  DELETE_ACCOUNT: "Delete Account",
  CONFIRM_ACCOUNT_DELETION: "Confirm Account Deletion",
  DELETE_ACCOUNT_WARNING_1:
    "You won't be able to log in or use this account anymore.",
  DELETE_ACCOUNT_WARNING_2:
    "All access will be blocked, and you will be removed from all sites.",
  DELETE_ACCOUNT_WARNING_3_PREFIX:
    "To remove access for specific buildings or units only, tap",
  DELETE_ACCOUNT_WARNING_3_SUFFIX: "and contact your property manager.",
  UNABLE_TO_DELETE_ACCOUNT: "Unable to Delete Account",
  UNABLE_TO_DELETE_ACCOUNT_PREFIX:
    "This account can’t be deleted because you are the last",
  UNABLE_TO_DELETE_ACCOUNT_SUFFIX: "on the following site(s):",
  UNABLE_TO_DELETE_ACCOUNT_FOOTER:
    "Add or activate another Property Manager Admin and try again.",
  ACTIVE_PROPERTY_MANAGER_ADMIN: "Active Property Manager Admin",
  ENTER_VERIFICATION_CODE_SENT_TO_PHONE:
    "Enter the verification code sent to your phone number ending in",
  ENTER_VERIFICATION_CODE_SENT_TO_EMAIL:
    "Enter the verification code sent to your email.",
  ACCOUNT_DELETION_SUBMITTED: "Account Deletion Submitted",
  ACCOUNT_DELETION_INFO:
    "Your deletion request is in progress and will complete within 14 days. An email confirmation will be sent when deletion is complete.",
  FAILED_TO_GENERATE_DELETE_CODE:
    "Failed to generate deletion code. Try again.",
  FAILED_TO_DEACTIVATE_ACCOUNT: "Failed to deactivate account. Try again.",
  NAME: "Name",
  NAME_ASTERIK: "Name*",
  PHONE_NUMBER: "Phone Number",
  FACE_ID: "Face ID",
  TWO_STEP_VERIFICATION: "2-Step Verification",
  PUSH_NOTIFICATION: "Push Notification",
  REQUEST_TO_GET_USER_INFO_FAILED:
    "Request to get info failed due to some error.",

  // users
  REMOVE_USER: "Remove this User",

  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_USER:
    "Are you sure you want to remove this User?",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_USER:
    "By moving forward you will lose all information associated with this user.",
  BEFORE_YOU_DELETE_THIS_USER: "Before You Delete This User",
  TO_DELETE_THIS_USER_PLEASE_ENSURE_PHYSICAL_CREDENTIALS:
    "To delete this user, please ensure that all standard credentials (cards and fobs) have been retrieved, If standard credentials are lost or stolen, please add them to the block list",
  NO_USER_IN_THIS_SITE: "No user in this site",
  NO_USER_IN_THIS_GROUP: "No user in this group",
  CREDENTIALS_ARE_RETRIEVED: "CREDENTIALS ARE RETRIEVED",
  ADD_TO_BLOCK_LIST: "ADD CREDENTIALS TO BLOCK LIST",
  PHYSICAL_CREDENTIALS_BLOCK_LIST:
    "To add standard credentials to the block list, please use the UNITE mobile app and navigate to User Profile > Standard Credential",
  BLOCK_LIST_REQUIRES_MOBILE_APP:
    "Add Credentials to Block List Requires Mobile App",
  CLOSE: "CLOSE",

  //Account Password Change Component
  PLEASE_ENTER_NEW_PASSWORD: "Please enter new password",
  NEW_PASSWORD: "New Password",
  REENTER_NEW_PASSWORD: "Re-enter New Password",
  OLD_PASSWORD: "Old Password",
  PASSWORD_UPDATED: "Password Updated",
  COMPLETED: "Completed!",
  INCORRECT_CURRENT_PASSWORD:
    "The password you entered does not match your account.",
  PASSWORD_DOES_NOT_MATCH:
    "The password you entered does not match your account.",
  FAILED_TO_UPDATE_USER: "Failed to update User detail.",
  FAILED_TO_UPDATE_MOBILE_CREDENTIAL: "Failed to update the Mobile credential.",
  FAILED_TO_DELETE_USER_ACCOUNT: "Failed to delete User account.",
  ACCOUNT_UPDATED: "Account Updated",
  FAILED_TO_GET_ADDRESS_SUGGESTIONS: "Failed to get addess suggestions.",

  //Account Name Change Component
  NEW_NAME: "New Name",
  PLEASE_ENTER_NEW_NAME: "Please enter a new name.",
  UPDATE: "UPDATE",
  NAME_UPDATED: "Name Updated",
  FIRSTNAME_LENGTH: "First Name should be between 2 and 30 characters long.",

  //DEVICE TYPE COMPONENT
  ADD_A_DEVICE: "Add a Device",
  UPDATE_A_DEVICE: "Update a Device",
  SELECT_A_DEVICE_TYPE: "Select a Device Type",
  SELECTE_A_DOOR_MODE: "Select a Door Mode",
  SELECTE_A_PROPER_DOOR_MODE:
    "Select the appropriate door mode for Lock/Unlock access point.",
  SELECT_A_PROPER_DEVICE_TYPE:
    "Select the appropriate device type for this access point.",
  DOOR_POSITION_SWITCH: "Door position switch",
  REQUEST_TO_EXIT: "Request to exit",
  LATCH_BOLT_MONITORING: "Latch bolt monitoring",
  LOCAL_ALARM: "Local alarm",
  ELECTRONIC_STRIKE: "Electronic strike",
  COMBO_READER_DEVICE: "Combo Reader",
  CONTROLLER_DEVICE: "Controller",

  //DEVICE NAME COMPONENT
  NAME_DEVICE: "Name Device",
  PERSONALIZE_YOUR_DEVICE:
    "Personalize your device experience by giving each access point a name to help you remember it.",
  YOU_MUST_ENTER_DEVICE_NAME: "You must enter device name.",

  //DEVICE INFORMATION COMPONENT
  ENTER_DEVICE_INFORMATION: "Enter Device Information.",
  ENTER_THE_DEVICE_INFORMATION_LISTED:
    "Enter the device information listed on your device.",
  ACTIVITIES: "Activities",
  DEVICE_NAME: "Device Name",
  DEVICE_TYPE: "Device Type",
  REMOVE_DEVICE: "Remove Device",
  ENABLE_DEVICE: "Enable Device",
  DISABLE_DEVICE: "Disable Device",

  // DEVICE ADDED COMPONENT
  GREAT_JOB: "Great job",
  DEVICE_ADDED: "Device Added",
  YOUR_DEVICE_IS_NOW_CONNECTED_TO_THE_APP:
    "Your device is now connected to the App.",
  DEVICE_INSTALLATION_REQUIRED: "Device installation Required.",
  DEVICE_INSTALLATION_REQUIRED_MESSAGE:
    "To complete the device setup process, installing and validating the credentials are working is required. To do so, you need to navigate to the mobile application.",
  COMPLETED_TEXT: "Completed",
  REQUEST_TO_DELETE_DEVICE_INFO_FAILED:
    "Request to delete device failed due to some error.",
  GREAT_JOB: "Great job",
  DEVICE_ADDED_SUCCESSFULLY: "Device added successfully.",
  DEVICE_UPDATED_SUCCESSFULLY: "Device updated successfully.",
  PARTNER_DEVICE_ALREADY_EXISTS: "Partner Device Already exists.",

  //Account Phone Number Change Component
  NEW_PHONE_NUMBER: "New Phone Number",
  PLEASE_ENTER_NEW_PHONE_NUMBER: "Enter new phone number",
  PHONE_UPDATED: "Phone Updated",
  PHONE_VERIFIED: "Phone Verified!",
  YOU_MUST_ENTER_A_VALID_REGION: "You must enter a valid region.",
  PHONE_NUMBER_ALREADY_EXISTS:
    "The phone number already exists. Please try a new one.",
  FAILED_TO_UPDATE_NAME: "Failed to update a name due to some error occurred.",
  CODE_NOT_FOUND: "Code not found.",
  WRONG_PHONE: "Please enter a valid phone number.",
  WRONG_CODE: "Entered Region code is not valid.",
  // delete account
  DELELE_ACCOUNT: "Delete Account",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ACCOUNT:
    "Are you sure you want to delete this account?",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_ASSO_THIS_ACC:
    "By moving forward you will lose all the information associated with this account.",

  // Add lock
  ADD_LOCK: "Add Lock",
  ADD_A_LOCK: "Add a Lock",
  FRONT_DOOR_SETTINGS: "Front Door Settings",
  ENTER_LOCK_INFO: "Enter Lock Info",
  ENTER_INFO_LISTED_YOUR_LOCK: "Enter the information listed on your lock.",
  SERIAL_NUMBER: "Serial Number*",
  MAC_ADDRESS_ADD_DEVICE: "Mac Address*",
  SERIAL_NUMBER_HASH: "Serial #",
  YOU_MUST_ENTER_SERIAL_NUMBER: "You must enter a valid serial number.",
  YOU_MUST_ENTER_VALID_MAC_ADDRESS: "You must enter a valid Mac Address.",
  YOU_MUST_ENTER_A_VALID_ACCESS_POINT_NAME:
    "You must enter a valid access point name.",
  SERIAL_NUMBER_ALPHA_NUMERIC:
    "The Serial number must be alphanumeric characters only.",
  SECURITY_TOKEN: "Security Token*",
  YOU_MUST_ENTER_SECURITY_TOKEN: "You must enter security token.",
  YOU_MUST_ENTER_LOCK_NAME: "You must enter lock name.",
  NAME_YOUR_LOCK: "Name Your Lock",
  NAMING_YOUR_LOCK: "Naming Your Lock",
  PERSONALIZE_YOUR_LOCK_EXPERIENCE:
    "Personalize your Lock experience by giving each of your locks a nickname to help you remember it.",
  GIVEN_A_NAME_TO_YOUR_LOCK:
    "When naming your lock, make sure it clearly describes the door location. For example, Front Door.",
  CONGRATS: "Congrats!",
  LOCK_ADDED: "Lock Added",
  LOCK_CONNECTED_TO_APP: "Your lock is now connected to the App.",
  LOCK_INSTALLATION_REQUIRED: "Lock installation Required.",
  LOCK_SETUP_COMPLETED:
    "To complete the lock setup process, installing and validating the credentials are working is required. To do so, you need to navigate to the mobile application.",
  FAILED_TO_ADD_DEVICE_SERVER_ERROR:
    "Failed to add device due to some error occurred.",
  LOCK_NAME_ALREADY_EXIST: "Lock name already exists in the unit.",
  DEVICE_ID_ALREADY_EXISTS: "Lock with same serial number already exists",
  DEVICE_ALREADY_EXISTS: "Lock is already present in the system",

  //Device Settings Component
  SETTING: "Setting",
  SETTINGS: "Settings",
  LOCK_NAME: "Lock Name",
  LOCK_SOUND: "Lock Sound",
  AUTO_LOCK: "Auto Lock",
  OPERATION_WINDOW: "Operation Window",
  USERS_ACCESS: "Users Access",
  INFORMATION: "Information",
  DEVICE_INFO: "Device Info",
  FIRMWARE_UPDATE: "Firmware Update",
  FIRMWARE_VERSION: "Firmware Version",
  HELP_FAQ: "Help/FAQ",
  FACTORY_RESET: "Factory Reset",
  REMOVE_LOCK: "Remove Lock",
  REQUEST_TO_GET_DEVICE_INFO_FAILED:
    "Request to get device info failed due to some error.",
  REQUEST_TO_UPDATE_DEVICE_NAME_FAILED:
    "Request to update device name failed due to some error.",
  DOOR_MODE: "Door Mode",
  DOOR_STATE: "Door State",
  WHEN_NAMING_YOR_LOCK_NAME:
    "When naming your lock, make sure it clearly describes the location.",
  EXAMPLE_LOCK_NAME: "For example, Front Door.",

  //Device Info Component
  BATTERY: "Battery",
  BATTERY_PERCENTAGE: "Battery Percentage",
  MODEL: "Model",
  MODEL_NUMBER: "Model Number",
  APP_VERSION: "App Version",
  MAC_ADDRESS: "Mac Address",
  LOCK_VERSION: "Lock Version",
  FIRMWARE: "Firmware",
  ACTIVATION_DATE: "Activation Date",
  MANUFACTURE_DATE: "Manufacture Date",
  BLUETOOTH: "Bluetooth",
  SEND_LOGS_UPPER_CASE: "SEND LOGS",
  SERIAL_NUM: "Serial Number",
  DEVICE_STATE: "Device State",
  DEVICE_STATUS: "Device Status",
  LOCK_STATUS: "Lock Status",
  LOCK_INFO: "Lock Info",
  DEVICE_NOT_FOUND: "Device not found.",
  USER_NOT_FOUND: "User not found.",
  USER_NOT_AUTHORIZED: "User in not authorized to perform this action.",
  PMU_CANNOT_MODIFY_PMA_PMU_USERS_DETAILS:
    "Property Manger Users may only edit access rights for users of a lower authority level in the system.",
  REQUEST_TO_GET_USERS_BY_DEVICE_FAILED:
    "Request to get user by device failed due to some error.",
  NOT_AVAILABLE: "N/A",

  // user group
  BUILD_USER_GROUPS: "Build Groups",
  USER_GROUP: "Groups",
  ASSIGN_A_GROUP: "Assign a Group",
  GROUPS: "Groups",
  GROUP: "Group",
  USER_TYPE: "User Type",
  CREATE_A_NEW_USER_GROUP_OR_EDIT:
    "Create a new Group  or edit existing ones below.",
  CREATE_NEW_GROUP: "CREATE NEW GROUP +",
  ADD_NEW_USER_GROUP: "ADD GROUP +",
  FAILED_TO_GET_GROUP_DETAILS: "Failed to get group details.",
  // add user group
  GROUP_NAME_ASTERISK: "Group Name*",
  GROUP_DESCRIPTION_ASTERISK: "Group Description*",
  YOU_MUST_ENTER_GROUP_NAME: "You must enter group name.",
  YOU_MUST_ENTER_GROUP_DESCRIPTION: "You must enter group description.",
  YOU_MUST_ENTER_VALID_GROUP_NAME: "You must enter a valid group name.",
  YOU_MUST_ENTER_VALID_GROUP_DESCRIPTION:
    "You must enter a valid group description.",
  ADD_USER_GROUP: "Add Group",
  ADD_USER_GROUP: "Add Group",
  ADD_USER_GROUPS: "Add Group",
  EDIT_GROUPS: "Edit Groups",
  USER_GROUP: "Groups",
  UPDATE: "UPDATE",
  CREATE_A_NAME_AND_ADD_DESCRIPTION:
    "Edit name and description for this Group.",
  ASSIGN_A_DEVICE_GROUP: "Assign a Device Group",
  ASSIGN_A_DEVICE_GROUP_TO: "Assign a device group to",
  GRANT_ACCESS_TO_USER_BY_SELECTING_A_BULIDING:
    "Select a building to start assigning access to the group.",
  SELECT_ANOTHER_BUILDING_TO_GRANT_MORE_ACCESS_POINTS_CONTINUE:
    "Select another building to grant more access points, otherwise continue.",
  BY_MOVING_FORWARD_ALL_USER_ACCESS_FOR_GROUP:
    "By moving forward all user access associated with this group will be removed.",
  FAILED_TO_LOAD_USER_GROUPS: "Failed to load groups.",
  FAILED_TO_ADD_USER_GROUP: "Group already exist.",
  FAILED_TO_UPDATE_USER_GROUP: "Failed to update group.",
  FAILED_TO_DELETE_USER_GROUP: "Failed to delete group.",
  NO_USER_GROUPS_AVAILABLE: "No groups available.",
  USER_GROUP_ADDED_SUCCESSFULLY: "Group Added.",
  USER_GROUP_UPDATED_SUCCESSFULLY: "Group Updated.",
  USER_GROUP: "Groups",
  ADDED: "Added!",
  UPDATED: "Updated!",
  DELETE_GROUP: "Delete Group",
  EDIT_GROUP: "Edit Groups",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_GROUP:
    "Are you sure you want to delete this group?",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO:
    "By moving forward you will lose all the information.",
  USER_NOT_INCLUDED_IN_THIS_GROUP: "User is not included in this group.",

  // header
  DASHBOARD: "Dashboard",
  LOCATIONS: "Buildings",
  USERS: "Users",
  LOGED_IN_AS: "Logged in as",
  ACCOUNT_SETTINGS: "Account Settings",
  USER_PROFILE: "User Profile",
  HELP_FAQ: "Help / FAQ",
  SEND_LOGS: "Send Logs",
  LOGOUT: "LOG OUT",

  // Profile
  MOBILE_CREDENTIAL: "Mobile Credentials",
  PHYSICAL_CREDENTIALS: "Standard Credentials",
  NO_PHYSICAL_CREDENTIALS: "No Standard Credentials",
  THERE_ARE_NO_PHYSICAL_CREDENTIALS:
    "There are no Standard Credentials associated with ",
  CREDENTIALS: "Credentials",
  USER_ACTIVITY: "User Activity",
  USER_GROUP: "Groups",
  USER_TYPE: "User Type",
  ACCESS: "Access",
  USER_ACCESS: "User Access",
  LAST_ACTVITIY: "Last Activity:",
  NO_USER_GROUPS: "No groups available.",
  ACCESS_ACTIVITY: "Access & Activity",
  REMOVE_GROUP: "Remove Group",
  REMOVE_USER_GROUP: "Remove user Group",
  REMOVE_GROUP: "Remove Group",
  ALL_ACCESS: "All Access",

  GROUP: "Group",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_GROUP:
    "Are you sure you want to remove this Group?",
  REMOVE_THIS_GROUP: "Remove this group",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_GROUP:
    "By moving forward you will lose all information associated with this group.",
  PROPERTY_MANAGER_ADMIN: "Property Manager Admin",
  PROPERTY_MANAGER_USER: "Property Manager User",
  INSTALLER_ADMIN: "Installer Admin",
  INSTALLER_USER: "Installer User",
  END_USER_ADMIN: "End-User Admin",
  RESIDENT_ADMIN: "Resident Admin",
  END_USER_USER: "End-User User",
  END_USER: "End User",
  RESIDENT: "Resident",
  ANY_TIME: "Anytime Access",

  //Restrict Remove Entities
  RESTRICT_REMOVE_UNIT:
    "To remove unit {}, all locks from the Unit must be removed. Currently there {} {} {},",
  MULTIPLE_LOCKS: "Locks",
  TO_REMOVE_LOCKS_FROM_A_UNIT_YOU_MUST_USE_THE_PROPERTY_MANAGER_MOBILE:
    "To remove locks from a unit, you must use the Property Management mobile application and be within Bluetooth range.",
  RESTRICT_REMOVE_ACCESSPOINT:
    "To remove access point {}, all devices from the Access Point must be removed. Currently there {} {} {},",
  TO_REMOVE_DEVICES_FROM_AN_ACCESS_POINT_YOU_MUST_USE_THE_PROPERTY_MANAGER_MOBILE:
    "To remove devices from an access point, you must use the Property Management mobile application and be within Bluetooth range.",
  NEED_HELP: "Need Help?",
  READ_OUR: "Read our",
  STEP_BY_STEP_GUIDE: "Step-by-Step Guide.",
  UNABLE_TO_REMOVE_UNIT: "Unable to remove unit {}",
  UNABLE_TO_REMOVE_ACCESS_POINT: "Unable to remove access point {}",
  IS: "is",
  TIME_IN_SECONDS: "s",
  ARE: "are",
  LOCK: "lock",
  DELETE_ACCESS_POINT: "Delete Access Point",
  UNABLE_TO_REMOVE_BUILDING: "Unable to remove building {}",
  RESTRICT_REMOVE_BUILDING:
    "To remove building {}, all floors from the building must be removed.",
  UNABLE_TO_REMOVE_FLOOR: "Unable to remove floor {}",
  RESTRICT_REMOVE_FLOOR:
    "To remove floor {}, all units from the floor must be removed.",
  DELETE_BUILDING: "Delete Building",
  DELETE_FLOOR: "Delete Floor",
  SEARCH_FOR_KEYWORDS: "Search for keywords",
  USER_NAME_IS_REQUIRED: "user Name is required.",
  DATE_RANGE: "Date Range",
  LOCK_TYPE: "Lock Type",
  USER_NAME: "User name",
  EMAIL: "Email",
  PHONE_NUMBER: "Phone Number",
  LOGIN_WITH_EMAIL: " Login with email",
  LOGIN_WITH_PHONE_NUMBER: " Login with phone number",
  UNLOCKED: "Unlocked",
  JAM: "jam",
  LOCKED: "Locked",
  FILTER_ACTIVITIES: "Filter Activities",
  BY: "By",
  TO: "to",
  SITE_OR_BUILDING_ID_CAN_NOT_BE_NULL: "Site or Building id can not be null.",
  YOUR_PASSWORD_UPDATE_LIMIT_HAS_EXCEEDED:
    "Your password update limit has exceeded, Please try again later.",
  ACTIVITY_TYPE: "Activity Type",

  // View Alert Component
  REPLACE_BATTERIES: "Replace Batteries",
  REPLACE_BATTERIES_STEP_1:
    "Obtain 4 AA batteries. For best results, use new, non-rechargeable alkaline batteries.",
  REPLACE_BATTERIES_STEP_2:
    "Remove the back panel and replace all four batteries.",
  REPLACE_BATTERIES_STEP_3: "The lock will automatically power back on.",
  REPLACE_BATTERIES_SYNC_NOTE:
    "After replacing the batteries, open the mobile app near the lock to sync and update the battery status.",
  LOCK_TEXT: "Lock",
  UNLOCK_TEXT: "Unlock",

  //User Access Messasge Component
  NO_LOCKS_PRESENT: "No Locks Present",
  NO_LOCKS_ARE_PRESENT_IN_SHARED_UNITS:
    "No Locks are present in the shared unit/units.",
  COMPREHENSIVE_ACCESS: "Comprehensive Access",
  COMPREHENSIVE_ACCESS_DESC:
    "The property Manager has access to all Buildings, Floors and Units in this site",
  ALL_SITE_ACCESS:
    "The {} has access to all Buildings, Floors and Units in this Site.",
  ALL_SITE_ACCESS_WITH_HIDDDEN_ACCESSPOINTS:
    "The {} has access to all Buildings, Floors and Units in this Site.",
  //User Profile Physical Credential
  ADD_CREDENTIAL: "Add Credential",
  UPDATE_ACCESS: "Update Access",
  STATUS: "Status:",
  DELETE_CREDENTIAL: "Delete Credential",
  DISABLE_ACCESS: "Disable Access",
  REQUEST_TO_GET_USER_CARDS_LIST_FAILED:
    "Request to get user crads list failed due to some error.",
  NO_CARDS_ASSOCIATED_WITH_GIVEN_USER:
    "No cards associated with the given user",
  ACTIVITY: "Activity",
  NO_ACTIVITY_AVAILABLE_FOR_THE_GIVEN_USER:
    "No activity available for the given user.",
  NO_ACTIVITY_AVAILABLE_FOR_THE_GIVEN_USER:
    "No activity available for the given user.",
  REQUEST_TO_GET_USER_ACTIVITY_FAILED: "Request to get user activity failed.",
  NO_USER_ACTIVITY_AVAILABLE: "No user activity available.",
  NO_ACCCESS_TO_SHOW: "No Access to Show.",
  FAILED_TO_REMOVE_USER_ACCESS: "Failed to remove user access.",
  ACCESS_SHARED_VIA_GROUP_CANNOT_BE_REMOVED_SEPARATELY:
    "Access shared via group cannot be removed separately.",
  ACCESS_SHARED_VIA_GROUP_CANNOT_BE_UPDATAED_SEPARATELY:
    "Access shared via group cannot be updated separately.",
  CARD_NOT_FOUND: "No card found against given card Id.",
  USER_ACCESS_NOT_FOUND: "No access information found against given card Id.",
  REQUEST_TO_GET_USER_CARD_DETAILS_FAILED:
    "Request to get user crads details failed due to some error.",
  ACCESS: "Access",
  REMOVE_ACCESS: "Remove Access",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_ACCESS:
    "Are you sure you want to remove this Access?",
  BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_ACCESS:
    "By moving forward you will lose all information associated with this access.",
  // dashboard user card
  SHOWINGS: "Showings",
  MAINTENANCE: "Maintenance",
  PRIVATE_EVENTS: "Private Events",
  TODAY: "Today",
  SHARED_ACCESS: "Shared Access",
  DEVICE_ISSUES: "Device Issues",
  ACTIVE_ISSUE: "Active Issues",
  REMAINING_INVITATIONS: "Remaining Invitations",
  CONTACT_SALES_FOR_MORE_INVITE:
    "Please contact our sales team to purchase more. Until then, you can still invite users.",
  AVAILABLE_UNITS: "Available Units",
  BACK_BUTTON: "< Back",
  ADD_GROUP: "Add Group",
  NO_DATA_TO_SHOW: "No data to show",
  NEW_PROFILE_PICTURE: "New Profile Picture",
  PLEASE_UPLOAD_NEW_PROFILE_PICTURE: "Please upload new profile picture.",
  PROFILE_PICTURE: "Profile Picture",
  PROFILE_PICTURE_IS_REQUIRED: "Profile picture is required.",
  CHOOSE_IMAGE: "Choose Image",
  ADD_GROUP: "Add Group",
  ASSIGN_USERS: "Assign Users",
  FAILED_TO_ADD_USER_TO_USER_GROUP: "Failed to add user(s) to user group",
  NO_LOCK_IN_THIS_SITE: "No lock in this site",
  REQUEST_TO_GET_LOCK_FAILED: "Request to get locks failed due to some error.",
  PLEASE_SELECT_A_LOCK_TO_DISPLAY:
    "Please select a lock to display their information",
  NO_RECORD_IN_THIS_SITE: "No record in this site",
  ACCESS_POINT_NAME_ALREADY_EXISTS:
    "Access Point with same name already exists",
  NO_EXPIRY: "No Expiry",
  SITE_ALREADY_EXISTS: "Site with same name already exists.",
  FLOOR_NAME_SHOULD_NOT_START_WITH_SPECIAL_CHARACTER:
    "Floor name must start with a Letter or Number.",
  UNIT_NAME_SHOULD_NOT_START_WITH_SPECIAL_CHARACTER:
    "Unit name should start with alphanumeric characters.",
  LOCK_NAME_SHOULD_NOT_START_WITH_SPECIAL_CHARACTER:
    "Lock name should start with alphanumeric characters.",
  NAME_SHOULD_START_WITH_ALPHABETIC_CHARACTER:
    "Name should start with alphabatic characters",
  YOUR_CONTROLLER_IS_OFFLINE: "Your controller is offline.",
  LOCK_AND_DEVICE: "Lock/Device",
  PLEASE_SELECT_A_LOCK_OR_DEVICE_TO_DISPLAY:
    "Please select a lock or device to display the information.",
  ALREADY_SHARED_TEXT: "Already shared",
  COPY_RIGHT_ALL_RESERVED:
    "Copyright © 2025, ASSA ABLOY Americas Residential Inc. All rights reserved. Reproduction in whole or in part without the express written permission of ASSA ABLOY Americas Residential Inc. is prohibited.",
  DEFINE_ACCESS_TIME_FOR_YOUR:
    "Define access time for your {}. The access time is in UTC {} {}.",
  USER_UPDATE_SUCCESSFULLY: "User {} {} has been updated successfully.",
  REMEMBER_UPDATE_PHYSICAL_CREDENTIAL:
    "Remember to use the mobile app to update your standard credential and stay in sync with mobile access.",
  // Filter Active Issues
  EVENT_TYPE: "Event Type",
  DELETE_TEXT: "DELETE",
  ARE_YOU_SURE_YOU_WANT_TO_REMOVE_ACCESS_FROM_USER:
    "Are you sure you want to remove access from the user?",
  KEEP_IN_MIN_USER_WILL_NO_LONGER_HAVE_ACCESS:
    "Keep in mind that user will no longer have access to those anymore.",
  SHARE_ACCESS_TO_SPECIFIC_UNIT_NOT_ALLOWED:
    "Share Access to specific unit is not allowed for provided role type",
  RESOURCE_ALREADY_SHARED: "Resource already shared",
  ACCESS_ALREADY_SHARED: "Access already shared.",
  ONE_OR_MORE_RESOURCES_ALREADY_SHARED:
    "One or more resources are already shared with the user.",
  PRIVACY_POLICY: "Privacy Policy",
  TERMS_OF_USE: "Terms of Use",
  SUPPORT_CENTER: "Support Center",
  PRODUCTS: "Products",
  WEB_ACCESSIBILITY: "Web Accessibility",
  HARDWARE_VERISON: "Hardware Version",
  HARDWARE_VARIANT: "Hardware Variant",
  FRENCH: "fr-ca",
  ENGLISH: "en-us",
};
